import styled from 'styled-components';

export const See3D = styled.div``;

export const Button = styled.button`
  align-items: center;
  background: #ffffff;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 1.1rem;
  justify-content: center;
  margin: 0;
  padding: 5px;
  margin-left: -5px;
  text-decoration: none;

  &:hover {
    ${See3D} {
      color: #0877bb;
    }
  }

  @media (max-width: 970px) {
    display: none;
  }
`;

export const MobileSectionLink = styled.a`
  align-items: center;
  background: #ffffff;
  color: #231f20;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 1.1rem;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
  text-decoration: none;
  display: none;

  &:focus,
  &:hover {
    outline: none;
  }

  @media (max-width: 970px) {
    display: flex;
  }
`;
